import React from "react";
import { StarSolid, Heart, ShareIos, ChatBubbleEmpty } from "iconoir-react";

interface PostActionsProps {
  post: {
    category?: string;
    is_liked: boolean;
    reactions_count: number;
    comments_count: number;
  };
  isLiking: boolean;
  onLikeClick: () => void;
  onShareClick: () => void;
}

export const PostActions: React.FC<PostActionsProps> = ({
  post,
  isLiking,
  onLikeClick,
  onShareClick,
}) => {
  const isHelpPost = post.category === "help";

  return (
    <div className="flex justify-between items-center px-4 py-3">
      {/* Left button */}
      {isHelpPost ? (
        <button
          className="flex items-center gap-1 bg-[#215E60] text-[#F4E7DA] px-3.5 py-2.5 rounded-full"
          onClick={(e) => e.stopPropagation()}
        >
          <StarSolid className="w-5 h-5 text-[#F4E7DA]" />
          <span className="text-sm font-medium font-sora leading-none">
            Sẵn sàng giúp
          </span>
        </button>
      ) : (
        <button
          onClick={onLikeClick}
          disabled={isLiking}
          className="flex items-center gap-1"
        >
          <Heart
            className="w-6 h-6"
            fill={post.is_liked ? "#000000" : "none"}
            stroke="#1E3A3A"
            strokeWidth={1.2}
          />
          {post.reactions_count > 0 && (
            <span className="text-sm text-[#1E3A3A] font-sora pl-1">
              {post.reactions_count}
            </span>
          )}
        </button>
      )}

      {/* Center button */}
      <button className="flex items-center gap-1">
        <ChatBubbleEmpty className="w-6 h-6" fill="none" />
        {post.comments_count > 0 && (
          <span className="text-sm text-[#1E3A3A] font-sora pl-1">
            {post.comments_count}
          </span>
        )}
      </button>

      {/* Right button */}
      <button onClick={onShareClick} className="flex items-center gap-1">
        <ShareIos className="w-6 h-6" stroke="#1E3A3A" strokeWidth={1.2} />
      </button>
    </div>
  );
};
